import React, { Component } from 'react'
import { Popover, Modal, Input, Button, Upload, Icon } from 'antd'
import { app, api, config } from '../../../../app'

import html2canvas from 'html2canvas';



class ProofEducation extends Component {
    // 组件内部
    constructor(props) {
        super(props)

        let uploadImgList = []

        if (props.fileInfo.length <= 0) {

        } else if (props.fileInfo[props.fileInfo.length - 1].img != undefined) {
            if (props.fileInfo[props.fileInfo.length - 1].img != '') {
                console.log(props.fileInfo)
                uploadImgList = props.fileInfo[props.fileInfo.length - 1].img.split(';;;')
                this.props.education_img(uploadImgList)
            }
        }

        // console.log(props)

        // if(props.com3.img != undefined){
        //     if(props.com3.img != ''){
        //         uploadImgList = props.com3.img.split(';;;')
        //     }
        // }

        this.state = {
            fileInfo: props.fileInfo,   //初始数据，一进入组件就请求获得

            isModalVisible: false,
            isModalVisible2: false,

            ProofEducationImg: '',
            submitOK: false,


            uploadImgList: uploadImgList,
            showMoadlImg: '',
            imgModal: false,
            whiteOK: false,  //是否已经提交过内容
            whiteModal: false,    //是否打开 注册申请表 编辑窗口
            defaultImgList: [],

        }
        this.getApplyinfo()


    }

    componentDidMount() {
        this.getDefaultImg()
        this.getExamineInfo()
        this.getApplyinfo()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.applyinfo !== this.props.applyinfo) {
            if (this.props.apply != 1) {
                return
            }
            // 值发生改变下一步工作
            const applyinfo = app.getData('applyinfo');
            console.log(applyinfo)

            let uploadImgList = this.state.uploadImgList;
            uploadImgList = applyinfo.file[6].img.split(';;;')
            this.props.education_img(uploadImgList)

            this.setState({
                uploadImgList
            })

        }
        if (nextProps.examineInfo !== this.props.examineInfo) {
            // 值发生改变下一步工作
            if (this.props.examine != 1) {
                return
            }
            const examineInfo = app.getData('examineInfo');

            let uploadImgList = this.state.uploadImgList;
            uploadImgList = examineInfo.file[examineInfo.file.length-1].img.split(';;;')
            this.setState({
                uploadImgList
            })
        }
    }



    //对默认展示图片进行处理
    getDefaultImg = () => {
        if (this.props.fileInfo.length <= 0) {
            return
        }
        // if (this.props.examine == 1) {
        //     return
        // }
        let defaultImgList = this.props.fileInfo[this.props.fileInfo.length -1].template_img.split(';;;')
        // console.log(defaultImgList)
        this.setState({
            defaultImgList
        })
    }

    getExamineInfo = () => {
        if (this.props.examine != 1) {
            return
        }
        const examineInfo = this.props.examineInfo;
        console.log(examineInfo)
        let uploadImgList = this.state.uploadImgList;
        uploadImgList = examineInfo.file[examineInfo.file.length-1].img.split(';;;')
        this.setState({
            uploadImgList
        })
    }

    getApplyinfo = () => {
        if (this.props.apply != 1) {
            return
        }
        const applyinfo = this.props.applyinfo;
        let uploadImgList = this.state.uploadImgList;
        uploadImgList = applyinfo.file[6].img.split(';;;')

        this.props.education_img(uploadImgList)

        this.setState({
            uploadImgList
        }, () => {
            console.log(this.state.uploadImgList)
        })
    }

    showModal = () => {
        this.setState({
            isModalVisible: true
        })
    }

    handleCancel = () => {
        this.setState({
            isModalVisible: false
        })
    }

    showModal2 = () => {
        this.setState({
            isModalVisible2: true
        })
    }

    handleCancel2 = () => {
        this.setState({
            isModalVisible2: false
        })
    }







    clickImg = (i) => {
        console.log(i.target.getAttribute('data-img'))
        this.setState({
            imgModal: true,
            showMoadlImg: i.target.getAttribute('data-img')
        })
    };

    deleImg = (i) => {
        const { uploadImgList } = this.state;
        uploadImgList.splice(i, 1)
        // this.props.deleteImg_education_img(i)
        this.props.education_img(uploadImgList)

        this.setState({
            uploadImgList
        })
    };


    clickImgCencel = () => {
        this.setState({
            imgModal: false
        })
    };



    white = () => {

        this.setState({
            whiteModal: true
        })
    }

    closeWhite = () => {
        this.setState({
            whiteModal: false
        })
    }

    downLoad = () => {
        this.setState({
            whiteModal: true
        }, () => {
            this.downloadJPG('JPGDOM', '存心救援队注册申请表')

        })

    }


    uploadImg = (info) => {
        if (info.file.status === 'uploading') {
            let flag = true
            this.props.uploadImgLoading(flag)
            return
        }
        if (info.file.status === 'done') {
            const res = info.file.response
            if (res.flag === 1) {
                console.log(res)
                app.alert(res.msg, 'success', '45%')
                // 将数据返回给父组件

                // let img = res.data.url;
                // this.props.reg_file_json(img, 'img')
                const { uploadImgList } = this.state;
                uploadImgList.push(res.data.url)
                // 当上传图片完成后将返回的图片放到本地以备用户预览
                this.props.education_img(uploadImgList)
                this.setState({
                    uploadImgList
                }, () => {
                    let flag = false
                    this.props.uploadImgLoading(flag)
                })
            } else {
                app.alert(res.msg, 'error', '45%')

            }
        }
    }



    lastImg = () => {
        let showMoadlImg = this.state.showMoadlImg;
        const { uploadImgList, defaultImgList } = this.state;
        let index
        if (uploadImgList.length < 1) {
            //如果用户没有上传图片，那么点击图片预览的是模版图片
            defaultImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 0) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 0) {
                return
            } else {
                showMoadlImg = defaultImgList[index - 1]
                this.setState({
                    showMoadlImg
                })
            }
        } else {
            //如果用户上传了图片，那么点击图片预览的是上传图片
            uploadImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 0) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 0) {
                return
            } else {
                showMoadlImg = uploadImgList[index - 1]
                this.setState({
                    showMoadlImg
                })
            }
        }


    }

    nextImg = () => {
        let showMoadlImg = this.state.showMoadlImg;
        const { uploadImgList, defaultImgList } = this.state;
        let index
        if (uploadImgList.length < 1) {
            defaultImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 2 || v == defaultImgList.length - 1) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 2 || index == defaultImgList.length - 1) {
                return
            } else {
                showMoadlImg = defaultImgList[index + 1]
                this.setState({
                    showMoadlImg
                })
            }
        } else {
            uploadImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 2 || v == uploadImgList.length - 1) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 2 || index == uploadImgList.length - 1) {
                return
            } else {
                showMoadlImg = uploadImgList[index + 1]
                this.setState({
                    showMoadlImg
                })
            }
        }


    }








    // 页面渲染区
    render() {
        let { fileInfo, ProofEducationImg, uploadImgList, defaultImgList } = this.state
        const content = (
            <div>
                <p>点击可预览模板</p>
            </div>
        )
        const imgList = uploadImgList.map((item, index) => {
            return (
                <Popover key={item} content={
                    <div >
                        <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={item}>预览</p>
                        {
                            this.props.examine == 1 || this.props.detailF == 1 ? '' :
                                <p style={{ cursor: 'pointer' }} onClick={() => this.deleImg(index)}>删除</p>
                        }
                    </div>
                }>

                    <img style={{ width: 90, height: 100, marginRight: 5 }} key={item} src={config.imgUrl + item} alt="" />
                </Popover>

            )
        })

        const defaultImg = defaultImgList.map((item, index) => {
            return (
                <Popover key={item} content={
                    <div >
                        <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={item}>预览模板</p>
                    </div>
                }>
                    <img style={{ width: 90, height: 100, marginRight: 5 }} key={item} src={config.imgUrl + item} alt="" />
                </Popover>

                // <img style={{ width: 90, height: 100, marginRight: 5 }} onClick={this.clickImg} data-img={item} key={item} src={config.imgUrl + item} alt="" />

            )
        })
        return (

            <div >
                <div style={{ width: 400, height: 200, borderWidth: 1, borderStyle: 'solid', borderColor: '#000' }}>
                    {/* 标题 */}
                    <p style={{ fontSize: 16, color: '#1890FF', paddingTop: 15, paddingLeft: 10 }}>
                        <Popover content={content}>
                            <span style={{ cursor: 'pointer' }} onClick={this.showModal}>《学历证明》</span>
                        </Popover>



                        <Modal title="学历证明" visible={this.state.isModalVisible} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.handleCancel}>

                            {
                                defaultImgList.map((item, index) => {
                                    return (

                                        <img style={{ width: 1150, marginRight: 5, borderBottom: 3, borderBottomStyle: 'solid', borderBottomColor: '#ddd' }} key={item} src={config.imgUrl + item} alt="" />

                                    )
                                })
                            }

                        </Modal>

                    </p>
                    {/* 标题end */}

                    {/* 资料框 */}
                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-around', width: '80%' }}>

                            <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3 }}>
                                {
                                    uploadImgList.length < 1
                                        ?
                                        defaultImg
                                        :
                                        imgList
                                }

                            </div>


                            <Modal title="学历证明" visible={this.state.imgModal} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.clickImgCencel}>
                                <p style={{ display: 'flex', justifyContent: 'space-around', color: '#1890ff', fontWeight: 'bold' }}>
                                    <div style={{ cursor: 'pointer' }} onClick={this.lastImg}>
                                        <Icon type="left" ></Icon> 上一张
                                    </div>
                                    <div style={{ cursor: 'pointer' }} onClick={this.nextImg}>
                                        下一张<Icon type="right" ></Icon>
                                    </div>
                                </p>
                                {

                                    <img src={config.imgUrl + this.state.showMoadlImg} alt="" style={{ width: 1000 }} />
                                }
                            </Modal>


                        </div>





                        {this.props.examine == 1 || this.props.detailF == 1 ? '' : uploadImgList.length == 3
                            ?
                            <div style={{ marginTop: 5 }} >上传</div>
                            :
                            <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} >
                                <Upload
                                    accept='image/jpeg, image/jpg, image/png'
                                    showUploadList={false}
                                    action={config.serverUrl + "/TeamApply/imageUpload"}
                                    name="image"
                                    onChange={this.uploadImg}
                                    style={{ color: '#1890FF' }}>上传</Upload>
                            </div>}







                    </div>
                    {/* 资料框 */}

                </div>
            </div>



        )
    }
}



export default ProofEducation



// WEBPACK FOOTER //
// ./src/routes/teamApplication/PreparatoryTeamApplicationDirectory/UploadInformationModal/ProofEducation.jsx